/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileImage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfileImage({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/Search/Patient/Search/Content/Profiles/Content/Profile/ProfileImage",
  presignedUrl
  
}) {
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 marginTop={dtSpaceXs}
 profile_url={presignedUrl}
 data="person"
 format="/Data/format.js initials"
 initials={personValueData}
 size="large"
/>
{children}
</React.Fragment>)
}